import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function UKCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>UK Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate in One of the World’s Most Trusted Jurisdictions</h3>
                            <p className='page-paragraph'>
                                A <b> UK company</b> offers unmatched <b> credibility and global market access.</b> With its <b> common law framework, respected regulatory system, and competitive tax options,</b> the UK is widely used by entrepreneurs, investors, and multinationals.
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Global Reputation",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Banking Access",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Flexible Structures",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "EU/US Business Gateway",
                                        icon: TiTick,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a UK Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Incorporate in the UK?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Tier-1 Jurisdiction",
                                    paragraph:
                                        "Respected by banks, regulators, and investors worldwide",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Options",
                                    paragraph: "LTDs, LLPs, PLCs for all business needs",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Global Banking Access",
                                    paragraph:
                                        "UK companies are widely accepted by banks & PSPs",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Opportunities",
                                    paragraph:
                                        "Corporate tax at 25% with planning options (R&D reliefs, holding structures)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EU & US Gateway",
                                    paragraph: "Excellent base for international business",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of UK Companies</h3>
                        <p className='page-subtitle'>1. Private Limited Company (LTD)</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "Most common structure",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph:
                                        "Ideal for SMEs, e-commerce, and international trading companies",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-subtitle'>2. Limited Liability Partnership (LLP)</p>
                        <PageList
                            items={[
                                {
                                    paragraph:
                                        "Flexible for professional services, consulting, and joint ventures",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Transparent tax treatment (partners taxed individually)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-subtitle'>3. Public Limited Company (PLC)</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "For larger businesses seeking capital raising",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-subtitle'>4. UK Branch / Subsidiary</p>
                        <PageList
                            items={[
                                {
                                    paragraph: "For foreign companies expanding into the UK market",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders",
                                    paragraph: "At least 1 (individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "Minimum 1 (must be individual, not only corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registered Office",
                                    paragraph: "Must be in the UK",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Secretary",
                                    paragraph: "Optional for LTDs",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "As low as GBP 1",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Filings",
                                    paragraph: "Annual accounts + confirmation statement",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of UK Company Formation</h3>
                        <PageList
                            items={[
                                {
                                    title: "Highest Global Credibility",
                                    paragraph: "Tier-1 reputation with full transparency",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EU/US Trade Gateway",
                                    paragraph: "Widely accepted for contracts and trade",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking & PSP Access",
                                    paragraph: "Strong links with European & global banking",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Reliefs",
                                    paragraph: "R&D credits, double-tax treaties, holding structures",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexibility",
                                    paragraph: "LTD, LLP, or PLC depending on business needs",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring",
                                    paragraph: "Choose LTD, LLP, or PLC based on your business model.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Check and reserve your company name with UK Companies House.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Preparation",
                                    paragraph: "Draft the Memorandum & Articles of Association.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Filing",
                                    paragraph: "Submit incorporation documents to Companies House for registration.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Certificate of Incorporation",
                                    paragraph: "Issued upon successful registration of your company.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Post-Incorporation",
                                    paragraph: "Open bank accounts, register for VAT, and begin operations.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "24–72 hours for LTD or LLP registration.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Cost",
                                    paragraph: "From GBP 1,200+ for a basic LTD package.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Includes accounting, annual filing, and registered office fees.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Common Uses of UK Companies</h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "E-commerce & trading firms",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Consulting & professional services",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Holding companies for EU/US ventures",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "FinTech & PSP startups",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Joint ventures & partnerships (LLP)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in UK company formation & compliance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Direct filing with Companies House & HMRC",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Integration with banking, PSPs, and tax advisors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "UK vs Cyprus vs Malta vs Isle of Man",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing support",
                                    paragraph: "Accounting, VAT, audits",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for the highest level of credibility in business incorporation?"
                        description="A <b>UK company</b> provides global recognition, strong banking access, and a flexible framework for international trade."
                        buttonText="Book a UK Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default UKCompanyFormation

const faqData = [
    {
        question: "How long does it take to register a UK company?",
        content: [
            { type: "answer", text: "As little as 24 hours for LTDs." },
        ],
    },
    {
        question: "Can foreigners own UK companies?",
        content: [
            { type: "answer", text: "Yes — 100% foreign ownership is permitted." },
        ],
    },
    {
        question: "What is the minimum capital?",
        content: [
            { type: "answer", text: "GBP 1 (but realistic funding expected for business operations)." },
        ],
    },
    {
        question: "Do UK companies pay tax?",
        content: [
            { type: "answer", text: "Yes — 25% corporate tax (with exemptions/reliefs possible)." },
        ],
    },
    {
        question: "Are accounts public?",
        content: [
            { type: "answer", text: "Yes — UK companies must file annual accounts, ensuring transparency." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "Our fintech company needed Tier-1 credibility. A UK LTD gave us instant banking access. Offshore Advisory guided us from incorporation to tax setup.",
        author: "Daniel W.",
        role: "FinTech Founder",
    },
    {
        quote:
            "We registered a UK LLP for our consultancy. Offshore Advisory managed the filings and provided ongoing accounting support.",
        author: "Amira T.",
        role: "Consultant",
    },
];